'use strict';

export default class Share {
    constructor() {
        $('body').on('click', '.share button', function (e) {
            e.preventDefault();

            var $this = $(this);
            var $title = $('html title').text();
            var $url = '';

            if ($this.hasClass('-facebook')) {
                $url = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(window.location.origin + window.location.pathname);
                var height = 300;
                var width = 500;
                var left = (screen.width / 2) - (width / 2);
                var top = (screen.height / 2) - (height / 2);

            window.open($url, "", "menubar=no, toolbar=no, resizable=yes, scrollbars=yes, width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
            } else if ($this.hasClass('-twitter')) {
                $url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.origin + window.location.pathname) + '&text=' + encodeURIComponent($title);
                var height = 300;
                var width = 500;
                var left = (screen.width / 2) - (width / 2);
                var top = (screen.height / 2) - (height / 2);

            window.open($url, "", "menubar=no, toolbar=no, resizable=yes, scrollbars=yes, width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
            } else if ($this.hasClass('-shareLink')) 
            {
                copyToClipboard();

            }

            
        });
    }
}

function copyToClipboard(text) {
    var inputc = document.body.appendChild(document.createElement("input"));
    inputc.value = window.location.href;
    inputc.focus();
    inputc.select();
    document.execCommand('copy');
    inputc.parentNode.removeChild(inputc);
    alert("URL Copied.");
    }
